import React, { useRef } from 'react';
import { useGesture } from '@use-gesture/react';

const ScrollView = ({ id, children, onNext, onPrev }) => {
  const wheeling = useRef(false);
  const speed = useRef(0);

  const handleScroll = (state) => {
    const { event, distance: [, y], direction: [, dy], velocity: [, velocityy] } = state;
    event.preventDefault();
    event.stopPropagation();

    // When a user flicks while the scroll momentum is still active,
    // the speed will suddently increase. Make sure to listen to that.
    if (Math.abs(state.delta[1]) > speed.current) {
      wheeling.current = true;
    }
    speed.current = Math.abs(state.delta[1]);

    // We only want to move a single slide at a time, so stop if busy.
    if (!wheeling.current) {
      return;
    }

    // If velocity is lower than a threshold, we assume we stopped scrolling.
    // Scrolling will continue due to momentum.
    if (velocityy !== 0 && velocityy < 0.25) {
      wheeling.current = false;
      return;
    }

    // We passed all checks, so assume we are scrolling.
    wheeling.current = true;

    if (y > 100) {
      if (dy > 0) {
        wheeling.current = false;
        if (event.type === 'pointermove') {
          onPrev();
        } else {
          onNext();
        }
      } else if (dy < 0) {
        wheeling.current = false;
        if (event.type === 'pointermove') {
          onNext();
        } else {
          onPrev();
        }
      }
    }
  };

  const target = useRef();
  useGesture(
    {
      onDrag: (state) => handleScroll(state),
      onDragStart: (state) => { wheeling.current = true; },
      onDragEnd: (state) => { wheeling.current = false; },
      onScroll: (state) => handleScroll(state),
      onScrollStart: (state) => { wheeling.current = true; },
      onScrollEnd: (state) => { wheeling.current = false; },
      onWheel: (state) => handleScroll(state),
      onWheelStart: (state) => { wheeling.current = true; },
      onWheelEnd: (state) => { wheeling.current = false; },
    },
    { target, eventOptions: { passive: false } },
  );

  return (
    <div ref={target}>
      { children }
    </div>
  );
};

export default ScrollView;
